import controller from './masterpass-card-delete-dialog.controller';

export default {
  controller,
  template: require('./masterpass-card-delete-dialog.html')
};



// WEBPACK FOOTER //
// src/app/buy/masterpass-card-delete-dialog/masterpass-card-delete-dialog.component.ts